import './ClaudiSticker.css';

type ClaudiStickerProps = {
  src: string;
  alt: string;
};

/** Earned Claudi sticker image on the reward screen. */
export function ClaudiSticker({ src, alt }: ClaudiStickerProps) {
  return (
    <img
      className="sticker-reward-claudi"
      src={src}
      alt={alt}
      draggable={false}
    />
  );
}
